export function typesToMap(registry, [Types, keys]) {
    const result = {};
    for (let i = 0; i < keys.length; i++) {
        result[keys[i]] = registry.getClassName(Types[i]) || new Types[i](registry).toRawType();
    }
    return result;
}
